module.exports = __webpack_public_path__ + "static/media/lachiripa-color.c1faa55f.png";